import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PrivatePageView() {
  const { slug } = useParams();

  useEffect(() => {
    document.title = 'Your Broker Portugal · Apresentação Privada';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    // Hide cookie banner & any other layout chrome on this route
    const style = document.createElement('style');
    style.id = 'private-page-style';
    style.innerHTML = `
      body { margin: 0 !important; overflow: hidden; background: #000; }
      [data-testid="cookie-consent-banner"] { display: none !important; }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(meta);
      const s = document.getElementById('private-page-style');
      if (s) document.head.removeChild(s);
    };
  }, []);

  return (
    <iframe
      data-testid="private-page-iframe"
      src={`${BACKEND_URL}/api/private-pages/${slug}/raw`}
      title="Apresentação Privada"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        zIndex: 1,
      }}
    />
  );
}
